(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('edistradadhluiApp')
        .constant('VERSION', "132.0.0-32-ga5d40189")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('API_URL', {
	"BE": "https://billing.dhlparcel.be/edistrada2/",
	"EC": "https://billing.dhlparcel.nl/edistrada2/",
	"NL": "https://billing.dhlparcel.nl/edistrada2/"
})
        .constant('SHELL_LOGO_HREF', "/")
;
})();
